import React from 'react';

import SegmentDashboardShell from '../../dashboard/SegmentDashboardShell';

export default function GovernmentDashboardPage() {
  return <SegmentDashboardShell variant="government" />;
}
